export default __webpack_public_path__ + "static/media/user.efbb89d9.svg";